import * as types from '../types.js';

/** Opções fixas de finalidade (valor 1–7) para entradas — enviadas como `purpose` na API. */
const PURPOSE_OPTIONS_INPUT = `
						<option value="1" selected>Compra ou recebimento para comercialização</option>
						<option value="2">Devolução de compra ou venda</option>
						<option value="3">Outra entrada (baixa / não especificada — CFOP 1949/2949)</option>
						<option value="4">Bonificação, doação ou brinde (entrada — CFOP 1949/2949)</option>
						<option value="5">Amostra grátis (entrada — CFOP 1949/2949)</option>
						<option value="6">Por conta e ordem de terceiros (entrada — CFOP 1949/2949)</option>
						<option value="7">Recebimento para depósito em armazém (entrada — CFOP 1905/2905)</option>`;

/** Saídas: somente finalidades padrão (sem CFOPs 5xxx da empresa). */
const PURPOSE_OPTIONS_OUTPUT_LEGACY = `
						<option value="1" selected>Venda de mercadoria</option>
						<option value="2">Devolução de compra ou venda</option>
						<option value="3">Baixa de estoque</option>
						<option value="4">Remessa em bonificação</option>
						<option value="5">Remessa de amostra grátis</option>
						<option value="6">Remessa por conta e ordem de terceiros</option>`;

function escapeHtml(s)
{
	return String(s ?? '')
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;');
}

function cfopDigits(code)
{
	return String(code ?? '').replace(/\D/g, '');
}

/** API / Postgres podem enviar venda como boolean, 0/1 ou string. */
function cfopIsVenda(c)
{
	const v = c?.venda;
	return v === true || v === 1 || v === '1' || v === 'true';
}

/** CFOP elegível no modal de gerar NF de saída: 5xxx, 6xxx ou marcado como venda no cadastro. */
function isOutputCfopChoice(c)
{
	const d = cfopDigits(c.code);
	if (d.startsWith('5') || d.startsWith('6'))
		return true;
	return cfopIsVenda(c);
}

/**
 * Monta o HTML interno do &lt;select id="purpose"&gt; para saídas:
 * CFOPs cadastrados (5xxx, 6xxx ou flag venda), depois finalidades padrão (1–6).
 * @param {Array<{ code: string, description: string, venda?: boolean }>} cfopRows
 */
export function buildOutputPurposeInnerHtml(cfopRows)
{
	const filtered = (cfopRows || [])
		.filter(isOutputCfopChoice)
		.sort((a, b) => cfopDigits(a.code).localeCompare(cfopDigits(b.code)));
	const parts = [];
	if (filtered.length)
	{
		parts.push('<optgroup label="CFOP cadastrado (5xxx, 6xxx ou marcado como venda)">');
		filtered.forEach((c, i) =>
		{
			const d = cfopDigits(c.code);
			const sel = i === 0 ? ' selected' : '';
			parts.push(`<option value="${d}"${sel}>${d} — ${escapeHtml(c.description)}</option>`);
		});
		parts.push('</optgroup>');
	}
	parts.push('<optgroup label="Finalidades padrão (CFOP calculado pelo sistema)">');
	const leg = PURPOSE_OPTIONS_OUTPUT_LEGACY.replace(
		'<option value="1" selected>',
		filtered.length ? '<option value="1">' : '<option value="1" selected>'
	);
	parts.push(leg);
	parts.push('</optgroup>');
	return parts.join('\n');
}

/**
 * @param {boolean} isInput true = Entradas (io_type I); false = Saídas (O)
 * @param {string | null} outputPurposeInnerHtml HTML completo das opções do select (saídas); null = legado só 1–6
 */
export default function buildCreateInvoicesForm(isInput, outputPurposeInnerHtml = null)
{
	const purposeBlock = isInput
		? PURPOSE_OPTIONS_INPUT
		: (outputPurposeInnerHtml != null ? outputPurposeInnerHtml : PURPOSE_OPTIONS_OUTPUT_LEGACY);
	const purposeLabel = isInput ? 'Finalidade' : 'Finalidade / CFOP';
	const purposeTitle = isInput
		? 'Finalidade da emissão (define o CFOP)'
		: 'CFOP cadastrado (5xxx, 6xxx ou venda) ou finalidade padrão do sistema';

	return {

		html: `
		<style>
			#create-invoices .purpose	{ width: 100%;	}
			#create-invoices #info		{ width: 30rem;	}
			#create-invoices #include
			{
				display: inline-block;
			}
		</style>
		<form id="create-invoices" class="form" autocomplete="off">
			<div class="title">
				Gerar notas para <span id="count"></span> <span id="io-noun">saídas</span>
			</div>
			<div class="mtl">
				<label class="purpose" title="${purposeTitle}">${purposeLabel}
					<select id="purpose" required>
						${purposeBlock}
					</select>
				</label>
			</div>
			<div>
				<label title="Informações complementares de interesse do contribuinte">Informações Complementares
					<textarea id="info" rows="6"></textarea>
				</label>
			</div>
			<div class="tal">
				<label title="Incluir observações dos pedidos nas informações complementares das notas">
					<input id="include" type="checkbox" checked>
					Incluir observações dos pedidos
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Cancelar</button>
				<button class='bn_Enter button'>Gerar</button>
			</div>
		</form>
	`,

		form:
		{
			selector: '#create-invoices',
			init(formset)
			{
				formset.form.eraseValues();
				Object.getPrototypeOf(this).init.call(this);
			},
		},

		fields: [
			{ properties: { selector: '#purpose' }, types: [types.select()] },
			{ properties: { selector: '#info' }, types: [types.textarea()] },
			{ properties: { selector: '#include' }, types: [types.checkbox()] },
		]

	};
}
